import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import { isAudioFile } from '../allowedFileTypes';
import { Action } from './FilesTable';

type FiledDocumentRowHandlers = {
  onPlay: (file: UploadedFile) => void;
  onCreateSubfolder: (file: UploadedFile) => void;
  onRenameFolder: (file: UploadedFile) => void;
  onMove: (file: UploadedFile) => void;
  onDelete: (file: UploadedFile) => void;
  onSelect?: (file: UploadedFile) => void;
  onUploadToSharepoint?: (file: UploadedFile) => void;
};

export function buildFiledDocumentRowActions(
  file: UploadedFile,
  handlers: FiledDocumentRowHandlers,
  options: { readOnly?: boolean } = {},
): Action<UploadedFile>[] {
  if (options.readOnly) return [];

  if ('categoryScope' in file) return [];

  const {
    onPlay,
    onCreateSubfolder,
    onRenameFolder,
    onMove,
    onDelete,
    onSelect,
    onUploadToSharepoint,
  } = handlers;
  const selectActions = onSelect ? [{ label: 'Select', action: onSelect }] : [];
  const move = { label: 'Move', action: onMove };
  const deleteAction = { label: 'Delete', action: onDelete, color: 'red' };

  if (file.isFolder) {
    return [
      { label: 'Create sub-folder', action: onCreateSubfolder },
      { label: 'Rename', action: onRenameFolder },
      move,
      deleteAction,
    ];
  }

  const sharepointAction = onUploadToSharepoint
    ? [{ label: 'Upload to SharePoint', action: onUploadToSharepoint }]
    : [];

  if (isAudioFile(file.file.fileType, file.file.fileName)) {
    return [
      { label: 'Play', action: onPlay },
      ...selectActions,
      move,
      ...sharepointAction,
      deleteAction,
    ];
  }

  return [...selectActions, move, ...sharepointAction, deleteAction];
}
